import { configureStore } from '@reduxjs/toolkit';
import ordersReducer from '../redux/feathers/ordersSlice';
import productsReducer from '../redux/feathers/productsSlice';

const store = configureStore({
  reducer: { products: productsReducer, orders: ordersReducer },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [
          // Ignore these action types
          'orders/updateOrdersAsync/fulfilled',
          'orders/postOrdersAsync/fulfilled',
          'orders/loadOrdersAsync/fulfilled',
          'orders/cancelOrdersAsync/fulfilled',
        ],
        ignoredPaths: [
          // Ignore these paths in the state
          'payload.config',
          'payload.headers',
          'payload.request',
        ],
      },
    }),
});

export default store;
